export const CAPABILITIES = [
  {
    id: "stakeholder",
    title: "Senior Stakeholder Management",
    blurb:
      "Credibility and trusted-advisor relationships at CMO, CXO, and major agency-leadership levels.",
    span: "md:col-span-7",
  },
  {
    id: "commercial",
    title: "Commercial Acumen",
    blurb:
      "Proven target ownership across TV, digital, and integrated media platforms.",
    span: "md:col-span-5",
  },
  {
    id: "adsales",
    title: "Digital Ad Sales & Metrics",
    blurb:
      "Precision management of ad inventories using CPM, CPC, and CPV pricing models.",
    span: "md:col-span-5",
    tags: ["CPM", "CPC", "CPV"],
  },
  {
    id: "sponsorship",
    title: "Sponsorship Sales",
    blurb:
      "Structuring and monetizing flagship industry IPs and invite-only events.",
    span: "md:col-span-7",
  },
];

export const STATS = [
  { value: 110, suffix: "%", label: "Target Achievement", sub: "in competitive South market portfolios" },
  { value: 100, suffix: "%+", label: "Revenue Growth", sub: "through disciplined pipeline management" },
  { value: 50, suffix: "+", label: "Marquee Accounts", sub: "premium global brands onboarded" },
];

export const BRAND_GROUPS = [
  {
    label: "Luxury & Lifestyle",
    brands: ["Titan", "Diageo", "BMW", "Movado", "Fossil", "Calvin Klein", "Beam Suntory", "Aditya Birla Fashion", "MG Select"],
  },
  {
    label: "Tech & Digital",
    brands: ["OnePlus", "Amazon", "Duolingo", "Myntra", "Flipkart"],
  },
  {
    label: "Mass Market & Services",
    brands: ["Acko Insurance", "Tata Tea", "Indo Nissin", "Britannia", "ITC", "Wipro"],
  },
];

export const MARQUEE_BRANDS = [
  "Titan", "Diageo", "BMW", "Movado", "Fossil", "Calvin Klein", "Beam Suntory",
  "Aditya Birla Fashion", "MG Select", "OnePlus", "Amazon", "Duolingo",
  "Myntra", "Flipkart", "Acko Insurance", "Tata Tea", "Indo Nissin",
  "Britannia", "ITC", "Wipro",
];

export const TIMELINE = [
  {
    company: "The Hollywood Reporter India",
    role: "Regional Manager",
    period: "2025 — Present",
    desc: "Owns revenue across strategic accounts via branded content, digital & print covers, and event/IP sponsorships. Building flagship invite-only properties like Creator List and Women in Entertainment.",
    current: true,
  },
  {
    company: "Brut India",
    role: "Manager",
    period: "2023 — 2024",
    desc: "Delivered 100%+ revenue growth and surpassed South-market targets by 110% through disciplined pipeline management and CXO-level engagement.",
  },
  {
    company: "Times Internet — Spotlight Team",
    role: "Manager",
    period: "2022",
    desc: "Delivered 360° TV & digital solutions across Times of India, Gadgets Now and 8 languages — closing partnerships with Myntra, OnePlus and Amazon.",
  },
  {
    company: "TVF / The Viral Fever",
    role: "Manager",
    period: "2019 — 2020",
    desc: "Sold digital video ad inventory on TVFPlay using CPM, CPC & CPV models; onboarded Acko Insurance, Titan Skinn and Tata Tea.",
  },
  {
    company: "Viacom18 Media / Voot",
    role: "Assistant Manager",
    period: "2015 — 2018",
    desc: "Drove digital ad sales during the launch of Voot OTT and grew the regional Colors channel client base across four markets.",
  },
];

export const CONTACT = {
  email: "Rohan.parihar@gmail.com",
  phone: "+91 98860 00478",
  location: "New Delhi, India",
  linkedin: "https://www.linkedin.com/feed/",
  resume: "/assets/RohanParihar_Resume.pdf",
};
